import {
  Avatar,
  Box,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";

const ProcessMovements = ({ process }) => {
  if (!process) {
    return null;
  }

  return (
    <Stack
      width={"100%"}
      direction={"column"}
      gap={1}
      bgcolor={"divider"}
      p={2}
      borderRadius={2}
    >
      <Box>
        <Typography variant="subtitle1" fontWeight={600}>
          Classes Vienna
        </Typography>
      </Box>      <List>
        {process?.classes_vienna?.length > 0 ? (
          process.classes_vienna.map((vienna) => (
            <>
              <ListItem>
                <ListItemText
                  primary={`Código: ${vienna.codigo}`}
                  style={{
                    fontWeight: 800,
                  }}
                  secondary={`Edição: ${vienna.edicao}`}
                />
              </ListItem>
              <Divider />
            </>
          ))
        ) : (
          <ListItem>Nenhuma classe vienna.</ListItem>
        )}
      </List>
      <Divider />
      <Box>
        <Typography variant="subtitle1" fontWeight={600}>
          Classes Nice
        </Typography>
      </Box>
      <List>
        {process?.classes_nice?.length > 0 ? (
          process.classes_nice.map((nice) => (
            <ListItem>
              <ListItemText
                primary={`Código: ${nice.codigo} - Situação da Classe: ${nice.status}`}
                style={{
                  fontWeight: 800,
                }}
                secondary={`Especificação: ${nice.especificacao}`}
              />
            </ListItem>
          ))
        ) : (
          <ListItem>Nenhuma classe nice.</ListItem>
        )}
      </List>
      <Box>
        <Typography variant="subtitle1" fontWeight={600}>
          Classe Nacional
        </Typography>
      </Box>
      <List>
        {process?.classe_nacional?.length > 0 ? (
          process.classe_nacional.map((nice) => (
            <ListItem>
              <ListItemText
                primary={`Código: ${nice.codigo} - Situação da Classe: ${nice.status}`}
                style={{
                  fontWeight: 800,
                }}
                secondary={`Especificação: ${nice.especificacao}`}
              />
            </ListItem>
          ))
        ) : (
          <ListItem>Nenhuma classe nacional.</ListItem>
        )}
      </List>
    </Stack>
  );
};

export default ProcessMovements;
